'use client'

import { usePage } from '@/components/providers/PageProvider'
import { formatFullNumber, formatSigFig } from '@/utils/formatUtil'

import styles from './HomeStats.module.scss'

export const HomeStats = () => {
  const { page } = usePage()

  const stats = page?.home?.stats

  const { totalCards, totalCommanders, totalDecks, totalWeeklyDecks } = stats || {}

  if (!totalCards || !totalCommanders || !totalDecks || !totalWeeklyDecks) return null

  return (
    <section className={styles.container}>
      <ul className={styles.list}>
        <li>
          <figure className={styles.stat}>{formatSigFig(totalDecks)}</figure>
          <h3>
            <span className={styles.statDescription}>Overall</span>
            <span className={styles.statSubject}>Decks</span>
          </h3>
        </li>
        <li>
          <figure className={styles.stat}>{formatSigFig(totalWeeklyDecks)}</figure>
          <h3>
            <span className={styles.statDescription}>Weekly</span>
            <span className={styles.statSubject}>Decks</span>
          </h3>
        </li>
        <li>
          <figure className={styles.stat}>{formatFullNumber(totalCommanders)}</figure>
          <h3>
            <span className={styles.statDescription}>All Time</span>
            <span className={styles.statSubject}>Commanders</span>
          </h3>
        </li>
        <li>
          <figure className={styles.stat}>{formatFullNumber(totalCards)}</figure>
          <h3>
            <span className={styles.statDescription}>All Time</span>
            <span className={styles.statSubject}>Cards</span>
          </h3>
        </li>
      </ul>
    </section>
  )
}
